module.exports = __webpack_public_path__ + "img/xyxfta.3eed0bdf.png";